// イベントメッセージセンター
export class MessageCenter
{
    // サブスクライバー
    private subscribers : Array<{object : any, messageId : string, callback : (parameter : any) => void}> = new Array();

    // メッセージを送る
    public send(messageId : string, parameter : any)
    {
        for(var subscriber of this.subscribers)
        {
            if(messageId == subscriber.messageId)
            {
                // 通知
                subscriber.callback(parameter);
            }
        }
    }

    // メッセージを受け取る
    public subscribe(object : any, messageId : string, callback : (parameter : any) => void)
    {
        // サブスクライバーを追加
        this.subscribers.push({object : object, messageId : messageId, callback : callback});
    }

    // メッセージ受け取りを終了
    public unsubscribe(object : any, messageId : string)
    {
        for(var i = this.subscribers.length - 1; i >= 0; --i)
        {
            var subscriber = this.subscribers[i];
            if(messageId == subscriber.messageId && object == subscriber.object)
            {
                // 通知削除
                this.subscribers.splice(i, 1);
            }
        }
    }
}